export default function WhatWeDo() {
  const capabilities = [
    {
      icon: 'ri-flow-chart',
      title: 'AI-Powered Workflow Automation',
      description: 'Streamline complex, multi-step processes with intelligent automation that adapts to your operational demands.',
    },
    {
      icon: 'ri-database-2-line',
      title: 'Intelligent Data Processing & Orchestration',
      description: 'Transform raw data into actionable intelligence with automated ingestion, validation, and routing pipelines.',
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Operational Dashboards & Reporting',
      description: 'Real-time visibility into every workflow, metric, and KPI — purpose-built for leadership and operations teams.',
    },
    {
      icon: 'ri-plug-line',
      title: 'Secure Integrations with Existing Platforms',
      description: 'Connect your existing tools into one seamless ecosystem — EHRs, CRMs, ERPs, and 500+ platforms.',
    },
    {
      icon: 'ri-robot-2-line',
      title: 'Custom AI Agents for Internal Operations',
      description: 'Deploy intelligent agents that handle inquiries, triage requests, and execute tasks autonomously — 24/7.',
    },
  ];

  return (
    <section className="py-20 lg:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <span className="text-primary text-sm font-semibold tracking-wider uppercase mb-3 block">
            Our Solutions
          </span>
          <h2 className="text-3xl lg:text-5xl font-display text-foreground mb-4 leading-tight">
            Intelligent Systems, Purpose-Built
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {capabilities.map((capability, index) => (
            <div
              key={index}
              className="group relative bg-card rounded-xl border border-border hover:border-primary/30 hover:shadow-lg hover:shadow-primary/5 transition-all duration-300 p-7"
            >
              <div className="w-12 h-12 mb-5 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                <i className={`${capability.icon} text-2xl text-primary`}></i>
              </div>
              <h3 className="text-lg font-display font-semibold text-foreground mb-3">
                {capability.title}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {capability.description}
              </p>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-muted-foreground mt-10">
          Every system is built for stability, security, and long-term scalability.
        </p>
      </div>
    </section>
  );
}